import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ShopHeroSection from './sections/ShopHeroSection';
import StorySection from './sections/StorySection';
import WhatsInSetSection from './sections/WhatsInSetSection';
import PhasesSection from './sections/PhasesSection';
import LifestyleSection from './sections/LifestyleSection';
import WhoForSection from './sections/WhoForSection';
import ShopTestimonialsSection from './sections/ShopTestimonialsSection';
import CheckoutSection from './sections/CheckoutSection';
import FAQSection from './sections/FAQSection';

const SectionDivider = () => (
  <div className="w-full h-px bg-accent-500/30" />
);

export default function Shop() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ShopHeroSection />
        <SectionDivider />
        <StorySection />
        <SectionDivider />
        <WhatsInSetSection />
        <SectionDivider />
        <PhasesSection />
        <SectionDivider />
        <LifestyleSection />
        <SectionDivider />
        <WhoForSection />
        <SectionDivider />
        <ShopTestimonialsSection />
        <SectionDivider />
        <CheckoutSection />
        <SectionDivider />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}